"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBanner = isBanner;
exports.isProduct = isProduct;
function isBanner(item) {
    return item.listerPosition !== undefined;
}
function isProduct(item) {
    return item.productId !== undefined;
}
//# sourceMappingURL=ProductTypes.js.map